import React from "react";
import styled from "styled-components/macro";
import TuluLogo from "../../images/logo3.png";
import monitor from "../../images/unit/monitor.png";
import darkMonitor from "../../images/unit/darkMonitor.png";

const MonitorBox = ({
  popupItem,
  frameColor,
  size,
  logo,
  isDraw,
  logoImage,
  colorUnit = "#4a4a4a",
  isCarpenter,
  isSticker,
  isWires,
  isElectric,
}) => {
  size = 384;
  const UpperShelf = styled.div`
    border: solid 1px #020202;
    background-color: rgba(0, 0, 0, 0);
    height: 9px;
  `;
  const MonitorElectricHall = styled.div`
    width: 50px;
    background-color: gray;
    height: 8px;
    border: black 1px dashed;
  `;

  return (
    <Box>
      {isDraw && (
        <UpperShelf>
          {isElectric && (
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              {" "}
              <MonitorElectricHall />
              <MonitorElectricHall />
            </div>
          )}{" "}
        </UpperShelf>
      )}
      <Box
        bgColor={isCarpenter ? "#c1ac8f" : "none"}
        style={{ flexDirection: "row" }}
      >
        {!isElectric && isWires && <WireRect />}
        <Wrapper isDraw={isDraw} frameColor={frameColor} size={size}>
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "flex-end",
            }}
          ></div>
        </Wrapper>
      </Box>

      {!isDraw && (
        <MonitorImg
          src={
            colorUnit === "linear-gradient(to bottom, #f7f7f7, #f1efef)"
              ? monitor
              : darkMonitor
          }
        />
      )}
      {}
      {isDraw && !isWires ? (
        <DrawMonitor>
          <InsideCarpenterMonitor />

          <div
            style={{
              position: "relative",
              bottom: -230,
              textAlign: "center",
            }}
          >
            {isCarpenter && !isSticker && (
              <p>
                Wooden Door
                <br />+ Monitor
              </p>
            )}
          </div>
        </DrawMonitor>
      ) : (
        <LogoWrapper>
          {!isWires && <Logo src={logo || TuluLogo} />}
          {!isElectric && isWires && <InnerText>Brain</InnerText>}
          {isElectric && <InnerText>1</InnerText>}
        </LogoWrapper>
      )}
    </Box>
  );
};

const LogoWrapper = styled.div`
  width: 182px;
  position: absolute;
  height: 392px;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DrawMonitor = styled.div`
  width: 115px;
  height: 220px;
  background-color: #606060;
  position: absolute;
  top: 96px;
  right: 30px;
`;

const InsideCarpenterMonitor = styled.div`
  width: 73px;
  height: 140px;
  background-color: #5f5f5f;
  position: absolute;
  top: 20px;
  right: 10px;
`;

const Logo = styled.img`
  width: 100px;
`;

const Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: -1;
  background-color: ${(props) => props.bgColor};
`;
const InnerText = styled.span`
  text-align: center;
  font-size: 22px;
  position: absolute;
  top: 80px;
`;
const WireRect = styled.div`
  position: absolute;
  top: 0;
  border: 1px solid black;
  left: 0;
  background-color: black;
  width: 42px;
  height: 10px;
  z-index: 999999999999;
`;
const Wrapper = styled.div`
  width: 180px;
  height: ${({ size }) => size}px;
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  border-radius: 2px;
  border: ${({ isDraw }) => (isDraw ? "1px solid black" : null)};
  background-color: ${({ frameColor, isDraw }) => (isDraw ? null : frameColor)};
`;

const MonitorImg = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  z-index: 100;
  transition: all 300ms ease-in-out;
`;
export { MonitorBox };
